import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./en.json";
import fr from "./fr.json";
import de from "./de.json";
import es from "./es.json";
import nl from "./nl.json";

// Supported languages — UI chrome only. Campsite descriptions are
// translated on-demand via /api/campsites/{id}/translate?lang=<code>
// and cached server-side so each campsite is only translated once
// per language ever.
export const SUPPORTED_LANGS = [
  { code: "en", label: "English",    flag: "🇬🇧" },
  { code: "fr", label: "Français",   flag: "🇫🇷" },
  { code: "de", label: "Deutsch",    flag: "🇩🇪" },
  { code: "es", label: "Español",    flag: "🇪🇸" },
  { code: "nl", label: "Nederlands", flag: "🇳🇱" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      de: { translation: de },
      es: { translation: es },
      nl: { translation: nl },
    },
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGS.map((l) => l.code),
    nonExplicitSupportedLngs: true, // map "fr-FR" → "fr"
    interpolation: { escapeValue: false }, // React already escapes
    detection: {
      // Try the user's saved choice first, then their browser locale.
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "cc-lang",
    },
  });

export default i18n;
